export default "__VITE_ASSET__BOG50W7P__"